import React, { useEffect, useState } from "react";
import { FirstPlaceIcon, SecondPlaceIcon, ThirdPlaceIcon } from "components/atoms/Icon";
import { TypeaheadSelect } from "components/atoms/TypeaheadSelect";
import { getLeaderboards } from "lib/actions";
import { ILeaderboardDTO, Option } from "types";
import { DropdownContainer, LeaderboardContainer, LeaderboardHeader, LeaderboardList, LeaderboardsContainer, ListItem, ListRank, ListUsername, ListVoteCount, ProfilePicture, SubTitle, UserCard, Username, UsernameContainer, VoteCount } from "./Leaderboard.styled";
const months = [{
  value: "currentMonth",
  label: "Current Month"
}, {
  value: "1",
  label: "January"
}, {
  value: "2",
  label: "February"
}, {
  value: "3",
  label: "March"
}, {
  value: "4",
  label: "April"
}, {
  value: "5",
  label: "May"
}, {
  value: "6",
  label: "June"
}, {
  value: "7",
  label: "July"
}, {
  value: "8",
  label: "August"
}, {
  value: "9",
  label: "September"
}, {
  value: "10",
  label: "October"
}, {
  value: "11",
  label: "November"
}, {
  value: "12",
  label: "December"
}];
const today = new Date();
const currentMonth = today.getMonth() + 1;
const currentYear = today.getFullYear();
const years = [{
  value: "currentYear",
  label: "Current Year"
}, ...Array.from({
  length: 2
}, (_, i) => ({
  value: `${currentYear - i}`,
  label: `${currentYear - i}`
}))];
const Leaderboard = () => {
  const [leaderboards, setLeaderboards] = useState<ILeaderboardDTO[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<Option | null>({
    value: `${currentMonth}`,
    label: months[currentMonth].label
  });
  const [selectedYear, setSelectedYear] = useState<Option | null>({
    value: `${currentYear}`,
    label: `${currentYear}`
  });
  const transformedMonths = months.map(option => ({
    value: option.value,
    label: option.label
  }));
  const transformedYears = years.map(option => ({
    value: option.value,
    label: option.label
  }));
  const fetchLeaderboard = async (month: string | undefined, year: string | undefined) => {
    try {
      const data: ILeaderboardDTO[] = await getLeaderboards(month, year);
      setLeaderboards(data);
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
    }
  };
  useEffect(() => {
    fetchLeaderboard(selectedMonth?.value === "currentMonth" ? undefined : selectedMonth?.value, selectedYear?.value === "currentYear" ? undefined : selectedYear?.value);
  }, [selectedMonth, selectedYear]);
  return <LeaderboardsContainer data-sentry-element="LeaderboardsContainer" data-sentry-component="Leaderboard" data-sentry-source-file="index.tsx">
            <DropdownContainer data-sentry-element="DropdownContainer" data-sentry-source-file="index.tsx">
                <TypeaheadSelect value={selectedMonth} onChange={option => setSelectedMonth(option)} options={transformedMonths} placeholder="Select month..." data-sentry-element="TypeaheadSelect" data-sentry-source-file="index.tsx" />
                <TypeaheadSelect value={selectedYear} onChange={option => setSelectedYear(option)} options={transformedYears} placeholder="Select year..." data-sentry-element="TypeaheadSelect" data-sentry-source-file="index.tsx" />
            </DropdownContainer>
            {leaderboards.map((leaderboard, index) => <LeaderboardContainer key={index}>
                    <SubTitle>{leaderboard.name}</SubTitle>
                    <LeaderboardHeader>
                        {leaderboard.entries.slice(1, 2).map((user, idx) => <UserCard key={user.username} rank={idx + 2}>
                                <ProfilePicture src={SecondPlaceIcon} width={50} height={50} alt={user.username} />
                                <UsernameContainer>
                                    <Username>{user.username}</Username>
                                    <VoteCount>{user.totalVoteCount}</VoteCount>
                                </UsernameContainer>
                            </UserCard>)}
                        {leaderboard.entries.slice(0, 1).map(user => <UserCard key={user.username} rank={1}>
                                <ProfilePicture src={FirstPlaceIcon} width={50} height={50} alt={user.username} />
                                <UsernameContainer>
                                    <Username>{user.username}</Username>
                                    <VoteCount>{user.totalVoteCount}</VoteCount>
                                </UsernameContainer>
                            </UserCard>)}
                        {leaderboard.entries.slice(2, 3).map((user, idx) => <UserCard key={user.username} rank={idx + 3}>
                                <ProfilePicture src={ThirdPlaceIcon} width={50} height={50} alt={user.username} />
                                <UsernameContainer>
                                    <Username>{user.username}</Username>
                                    <VoteCount>{user.totalVoteCount}</VoteCount>
                                </UsernameContainer>
                            </UserCard>)}
                    </LeaderboardHeader>
                    <LeaderboardList>
                        {leaderboard.entries.slice(3).map((user, index) => <ListItem key={user.username}>
                                {/* <ListProfilePicture
                                    src={Award}
                                    width={50}
                                    height={50}
                                    alt={user.username}
                                 /> */}
                                <ListRank>{index + 4}.</ListRank>
                                <ListUsername>{user.username}</ListUsername>
                                <ListVoteCount>
                                    {user.totalVoteCount}
                                </ListVoteCount>
                            </ListItem>)}
                    </LeaderboardList>
                </LeaderboardContainer>)}
        </LeaderboardsContainer>;
};
export default Leaderboard;